import * as React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import PrivacyPolicy, {
  PrivacyPolicyTitle,
} from '../../../../components/home/PrivacyPolicyAyalaMalls/PrivacyPolicy'

const StyledPrivacyPolicy = styled(PrivacyPolicy)`
  padding: 1rem;
`
const StyledTitle = styled.h2`
  text-align: center;
  color: var(--color-primary);
`

const MainView = props => {
  const [hasTitle, setHasTitle] = React.useState(false)

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    setHasTitle(!urlParams.has('noTitle'))
  }, [])

  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
            display: none !important;
          }`}
        </style>
      </Helmet>
      {hasTitle && (
        <StyledTitle>
          <PrivacyPolicyTitle />
        </StyledTitle>
      )}
      <StyledPrivacyPolicy />
    </>
  )
}

export default MainView
